import type { GridApi } from 'ag-grid-community';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { findCurrentUserEvent } from '../../../../../shared/lib';
import { currentEventIdState } from '../../../../../state/event';
import { checkIsPrepareChildField } from '../lib/checkIsPrepareChildField';
import { newChildTaskState } from './store/newChildTask.state';

interface UpdateRowParams {
  id: string;
  colField: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  api: GridApi;
}
export const useUpdateRowTransaction = () => {
  const setChildState = useSetRecoilState(newChildTaskState);
  const currentEventId = useRecoilValue(currentEventIdState);

  const handleUpdateRow = (params: UpdateRowParams) => {
    const { api, colField, value, id } = params;

    if (checkIsPrepareChildField(id)) {
      setChildState((prev) => {
        const newValue = {
          ...prev,
          [colField]: value,
        };

        if (colField === 'responsible' && currentEventId) {
          if (value?.userEvents) {
            const userEvent = findCurrentUserEvent(currentEventId)(value.userEvents);
            newValue.userFunction = userEvent?.function;
          } else {
            newValue.userFunction = undefined;
          }
        }

        api.applyTransaction({
          update: [newValue],
        });

        return newValue;
      });
    }
  };

  return {
    callbackIdString: handleUpdateRow,
  };
};
